import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    translate: `${APP_CONFIG.translate_host}/Translator/Translate`,
    auth: `${APP_CONFIG.translate_host}/Auth/token`,
  },
}
